import { fromJS, Map, List } from 'immutable';
import Actions from 'flow/actions';

const initialState = Map();

export const soundsReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_USER_SOUNDS: {
            return state.update('sounds', () => fromJS(action.data));
        }
        case Actions.RESULT_CREATE_NEW_SOUND: {
            return state.update('sounds', (prev = List()) =>
                prev.push(fromJS(action.data)),
            );
        }
        case Actions.RESULT_EDIT_SOUND: {
            const index = state
                .get('sounds')
                .findIndex((i) => i.get('key') === action.key);
            return state.update('sounds', (prev) =>
                prev.set(index, fromJS(action.data)),
            );
        }
        case Actions.RESULT_REMOVE_SOUND: {
            const sounds = state
                .get('sounds')
                .filter((sounds) => sounds.get('key') !== action.key);
            return state.set('sounds', sounds);
        }
        case Actions.RESULT_DEFAULT_SOUNDS: {
            return state.update('defaultSounds', () => fromJS(action.data));
        }
        case Actions.PLAY_SOUND: {
            return state.update('playSound', () => fromJS(action.data));
        }
        default: {
            return state;
        }
    }
};

export default soundsReducer;
